import React, { Fragment, useCallback, useMemo, useState } from "react";
import { arrayOf, func, node, string } from "prop-types";

import { MenuChangeContext, MenuStateContext } from "./MenuContext";
import MultiLevelMenu from "./MultiLevelMenu";

const RootMenu = ({ children, render, subMenuArray, title }) => {
  const [tree, setTree] = useState([title]);
  const onBack = useCallback(() => {
    setTree(prevLevels => prevLevels.slice(0, -1));
  }, []);
  const onMenuOpen = useCallback(subMenuTitle => {
    setTree(prevLevels => [...prevLevels, subMenuTitle]);
  }, []);
  const menuStateValue = useMemo(
    () => ({
      tree,
      currentLevel: tree[tree.length - 1] || ""
    }),
    [tree]
  );
  const menuChangeValue = useMemo(
    () => ({
      onBack,
      onMenuOpen
    }),
    [setTree]
  );
  const contextValue = useMemo(
    () => ({
      ...menuStateValue,
      ...menuChangeValue
    }),
    [menuStateValue, menuChangeValue]
  );

  return (
    <MenuChangeContext.Provider value={menuChangeValue}>
      <MenuStateContext.Provider value={menuStateValue}>
        <MultiLevelMenu title={title}>
          {typeof render === "function" ? render(contextValue) : children}
        </MultiLevelMenu>
        {subMenuArray.map((level, index) => (
          <Fragment key={index.toString()}>{level}</Fragment>
        ))}
      </MenuStateContext.Provider>
    </MenuChangeContext.Provider>
  );
};

RootMenu.propTypes = {
  render: func,
  children: node,
  subMenuArray: arrayOf(node),
  title: string
};

RootMenu.defaultProps = {
  children: undefined,
  render: undefined,
  subMenuArray: [],
  title: "Main Menu"
};

export default RootMenu;
